export default "__VITE_ASSET__7c9125f6__"